import { Injectable } from '@angular/core';
import { GlobalDataService } from '../../housekeeping/services/global-data.service';
import { GlobalVariable } from '../../../../app/config';

@Injectable()
export class OwnerCrudService {
    public BASE_URL = GlobalVariable.FORDAPIEndPointURL;
    constructor(public _globalDataService:GlobalDataService) { }


    viewOwnerDetails(vin, ownerId, userId,ownerVehicleId, callback) {
         this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/details?userId="+userId+"&ownerId="+ownerId+"&vin="+vin+"&ownerVehicleId="+ownerVehicleId, (result) => {
            callback(result);
        })
    }

  saveOwner(ownerObj,callback){
    this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/owner/save",ownerObj, (result) => {
      callback(result);
    })
  }
  saveBulkOwner(payload,userId,callback){
    this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/owner/save-bulk?userId="+userId,payload, (result) => {
      callback(result);
    })
  }

    saveChangeOwner(ownerObj,callback){
        this._globalDataService.PostAjaxCall(this.BASE_URL + "/lms/owner/changeOwner",ownerObj, (result) => {
            callback(result);
        })
    }

    getsalesList(userId,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/salesType/list", (result) => {
            callback(result);
        })
    }
    getOwnershipcycle(userId,callback){
        this._globalDataService.GetAjaxCall(this.BASE_URL + "/lms/owner/cycle/list", (result) => {
            callback(result);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/owners/services/owner-crud.service.ts